interface SortIconProps {
  active?: boolean;
  direction?: "asc" | "desc" | null;
}

export function SortIcon({ active, direction }: SortIconProps) {
  const blueColor = `var(--chakra-colors-gray-200)`;
  const grayColor = `var(--chakra-colors-gray-500)`;
  const topTriangleColor = active && direction === "asc" ? blueColor : grayColor;
  const bottomTriangleColor = active && direction === "desc" ? blueColor : grayColor;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 8 10" fill="none">
      <g clipPath="url(#clip0_7382_36009)">
        <path d="M8 6H0L4 10L8 6Z" fill={bottomTriangleColor} />
        <path d="M9.53674e-07 4L8 4L4 -1.27146e-07L9.53674e-07 4Z" fill={topTriangleColor} />
      </g>
      <defs>
        <clipPath id="clip0_7382_36009">
          <rect width="8" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
